import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";

const baseURL =
  import.meta.env.VITE_SURA_NOVELTIES_BACKEND_API_URL ||
  "http://localhost:4010/api";

const suraNoveltiesApi: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

setupAuthInterceptor(suraNoveltiesApi);

suraNoveltiesApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error.response || "Algo salió mal");
  },
);

export { suraNoveltiesApi };
